import Modal from "../../../UI/Modal/Modal"
import classes from "../../AdminForm.module.css"
import { Controller, useFieldArray, useForm } from "react-hook-form"
import Field from "../../../UI/Field/Field"
import Input from "../../../UI/Form/Input"
import { useEffect } from "react"
import CustomButton from "../../../UI/CustomButton/CustomButton"
import { AiOutlinePlus } from "react-icons/ai"
import PricingSection from "../PricingSection/PricingSection"
import CustomCheckbox from "../../../UI/Form/CustomCheckbox"
import { connect } from "react-redux"
import { updateTicketType } from "../../../../Redux/eventsReducer"
import CustomAutocomplete from "../../../UI/Form/CustomAutocmplete"

const EditTicketType = (props) => {
    const { onClose, updateTicketType, eventId, setTicketTypesData, ticketTypes, currentTicketType, event } = props

    const {
        handleSubmit,
        control,
        reset,
        setValue
    } = useForm({
        shouldFocusError: true,
        mode: 'onChange',
        reValidateMode: 'onChange'
    })

    const {
        fields: priceFields,
        append: priceAppend,
        remove: priceRemove
    } = useFieldArray({ control, name: "price" })

    const addPriceSection = () => {
        priceAppend({ price: "", start: "", end: "" })
    }

    const removePriceSection = (index) => {
        if (priceFields.length > 1) {
            priceRemove(index)
        }
    }

    const onError = (errors) => {
        const firstErrorField = Object.keys(errors)[0]; // "date", "endDate" и т.д.
      
        const fieldElement = document.querySelector(`[name="${firstErrorField}"]`);
        if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    const onSubmit = (data) => {
        data.days = [...data.days].sort((a, b) => new Date(a.date) - new Date(b.date))
        updateTicketType(currentTicketType._id, { ...data, eventId: eventId } )
        .then(newTicketType => {
            if (newTicketType) {
                const updatedList = ticketTypes.map(t =>
                    t._id === newTicketType._id ? newTicketType : t
                )
                setTicketTypesData(updatedList)
            }
        })
    }

    useEffect(() => {
        reset({ ...currentTicketType, days: currentTicketType.days })
    }, [currentTicketType])

    return (
        <Modal title={`Edit ${currentTicketType.name} type`} onClose={onClose}>
            <form className={classes.main} onSubmit={handleSubmit(onSubmit, onError)}>
                <Field>
                    <Controller
                        name="name"
                        control={control}
                        defaultValue=""
                        rules={{ required: "Required Field!" }}
                        render={({
                            field: { onChange, value, name },
                            fieldState: { error }
                        }) => (
                            <Input
                                name={name}
                                onChange={onChange}
                                value={value}
                                error={error}
                                label="Ticket type name"
                            />
                        )}
                    />
                </Field>
                <div style={{ marginTop: "10px" }}>
                    <Controller
                        name={"days"}
                        control={control}
                        defaultValue={[]}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <CustomAutocomplete
                                value={value}
                                onChange={onChange}
                                items={event.dates}
                                multiple={true}
                                label={"Days Access"}
                                error={error}
                                setValue={setValue}
                                name={"days"}
                            />
                        )}
                    />
                </div>
                <Field>
                    <Controller
                        name="isHaveBackStageAccess"
                        control={control}
                        defaultValue=""
                        render={({
                            field: { onChange, value },
                            fieldState: { error }
                        }) => (
                            <CustomCheckbox
                                checked={value}
                                onChange={onChange}
                                label="Backstage access"
                            />
                        )}
                    />
                </Field>
                <Field className={classes.sectionHeader}>
                    <h3>Pricing</h3>
                    <CustomButton
                        className={classes.addBut}
                        onClick={addPriceSection}
                    >
                        <AiOutlinePlus />
                        <span>Add new Level</span>
                    </CustomButton>
                </Field>
                <Field direction="column">
                    {priceFields.map((el, index) => (
                        <PricingSection
                            key={el.id}
                            index={index}
                            control={control}
                            onRemove={removePriceSection}
                        />
                    ))}
                </Field>
                <CustomButton type="submit">Save</CustomButton>
            </form> 
        </Modal>
    )
}

export default connect(null, {
    updateTicketType
})(EditTicketType)